<template>
  <section class="column">
    <table-treinamentos :id="userId" />
    <q-separator style="margin-top: 40px; margin-bottom: 30px" />

    <table-participacao :id="userId" />
  </section>
</template>

<script setup>
import { computed } from "@vue/reactivity";
import { defineProps } from "vue";
import TableParticipacao from "./TableParticipacao.vue";
import TableTreinamentos from "./TableTreinamentos.vue";

const props = defineProps({
  id: {
    type: Number,
  },
});

const userId = computed(() => props.id);
</script>

<style></style>
